import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * Shows a brief loading overlay when the language changes
 * to mask layout shifts (especially RTL/LTR switches).
 */
export function useLanguageTransition(durationMs = 500) {
  const { i18n } = useTranslation();
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleLanguageChanged = () => {
    setIsTransitioning(true);
    setTimeout(() => setIsTransitioning(false), durationMs);
  };

  useEffect(() => {
    i18n.on("languageChanged", handleLanguageChanged);
    return () => {
      i18n.off("languageChanged", handleLanguageChanged);
    };
  });

  return isTransitioning;
}
